import React, { useRef, useCallback } from 'react';
import { KiteCard, KiteAlert, KiteIcon } from '@kite/react-kite';
import { ITCOForm, ITCOSubmission } from 'types';
import { useTCORenderFields } from 'hooks';
import './TCOTrainingEducation.scss';

export interface ITCOTrainingEducationCostsProps {
  form: ITCOForm;
  tcoSubmissions: ITCOSubmission[];
}

const TCOImplementationCostsTrainingEducationCosts = ({
  form,
  tcoSubmissions,
}: ITCOTrainingEducationCostsProps) => {
  const { name, fields, id } = form;
  const ref = useRef<HTMLFormElement>(null);

  const { fieldComponents, updateTcoSubmissionsError } = useTCORenderFields({
    fields,
    tcoSubmissions,
    formId: id,
  });

  const handleSubmit = useCallback((e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  }, []);

  return (
    <KiteCard className="tco-training-education">
      <h3 className="tco-training-education__title">{name}</h3>
      <div className="implementation-costs">
        {updateTcoSubmissionsError && (
          <KiteAlert
            type="alert"
            title="Save Error"
            description="Something went wrong saving your answers. Any changes will not be saved. Please refresh and try again later."
          />
        )}
        <form ref={ref} onSubmit={handleSubmit}>
          <div className="implementation-costs__training-education-container">
            <div className="implementation-costs__training-education-spectrum">
              <h4 className="implementation-costs__section-title">SPECTRUM</h4>
              <div className="implementation-costs__content">
                <div className="implementation-costs__included-item">
                  <KiteIcon
                    name="checkmark-circle-f"
                    color="green"
                    size="24px"
                  />
                  <span className="implementation-costs__included-text">
                    Training/Educational Costs Included
                  </span>
                </div>
              </div>
            </div>
            <div className="implementation-costs__vertical-divider"></div>
            <div className="implementation-costs__training-education-diy">
              <h4 className="implementation-costs__section-title">DIY</h4>
              <div className="implementation-costs__inputs">
                {fieldComponents}
              </div>
            </div>
          </div>
        </form>
      </div>
    </KiteCard>
  );
};

export default TCOImplementationCostsTrainingEducationCosts;
